import { CarouselSectionTypes, CarouselTiledCards, ImageCarouselDeck } from '@dfh-corp-sites/ui'
import React, { useMemo, useState } from 'react'

import { CarouselSectionProps, SanityImageCarouselDeck } from './types'
import { transformImageSlide, transformLink } from './utils'

const transformImageDeck = (deck: SanityImageCarouselDeck): ImageCarouselDeck => {
  return {
    ...deck,
    imageSlides: deck.imageSlides?.map((slide, index) => {
      return transformImageSlide({
        ...slide,
        _key: slide._key ?? String(index),
        type: slide.type ?? CarouselSectionTypes.Image,
      })
    }),
    cta: deck.cta && transformLink(deck.cta),
  }
}

function CarouselSectionImageSidenav({
  carouselDecks,
  title,
  subtitle,
  text,
}: Pick<CarouselSectionProps, 'carouselDecks' | 'title' | 'subtitle' | 'text'>) {
  const [activeSlide, setActiveSlide] = useState(0)

  const processedDecks = useMemo(() => {
    return carouselDecks?.map(transformImageDeck)
  }, [carouselDecks])

  if (!processedDecks?.length) {
    return null
  }

  return (
    <div className="relative left-1/2 transform -translate-x-1/2 w-screen">
      <section className="w-full">
        <CarouselTiledCards
          sliderType={CarouselSectionTypes.Image}
          title={title}
          subtitle={subtitle}
          text={text}
          activeSlide={activeSlide}
          onSlideChange={(swiper: { realIndex: number }) => setActiveSlide(swiper.realIndex)}
          decks={processedDecks}
        />
      </section>
    </div>
  )
}

export default CarouselSectionImageSidenav
